export const valoresExibidosFornecedor: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorCEP: '',
  separadorContato: '',
  separadorFuncionalidade: '',

  //Específicos
  hierarquia: 'Hierarquia',
  porte: 'Porte',
  cnpj: 'CNPJ',
  razaoSocial: 'Razão Social',
  nomeFantasia: 'Nome Fantasia',
  dataAbertura: 'Data Abertura',
  telefone1: 'Telefone principal',
  telefone2: 'Telefone secundário',
  email: 'Email',
  site: 'Site',
  cep: 'CEP',
  bairro: 'Bairro',
  logradouro: 'Logradouro',
  numeroImovel: 'Numero Imóvel',
};

export const valoresExibidosRepresentantes: Record<string, string> = {
  //Logs
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',

  //Observações
  observacoes: 'Observações',

  //Dados da entidade
  generoSexual: 'Gênero',
  cargoFuncao: 'Cargo',
  cpf: 'CPF',
  nomeCompleto: 'Nome Completo',
  dataNascimento: 'Data Nascimento',
  telefone: 'Telefone',
  celular: 'Celular',
  email: 'Email',
  linkedin: 'Linkedin',

  //Dados do Fornecedor
  fornecedorId: 'ID do Fornecedor',
  cnpj: 'CNPJ',
  razaoSocial: 'Razão Social',
};

export const valoresExibidosComunicacoes: Record<string, string> = {
  //Logs
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',

  //Observações
  observacoes: 'Observações',

  //Dados da entidade
  unidadeDAF: 'Unidade DAF',
  tipoComunicacao: 'Tipo de Comunicação',
  topicoComunicacao: 'Tópico da Comunicação',
  statusEnvio: 'Status do Envio',
  dataEnvio: 'Data do Encaminhamento',
  assunto: 'Assunto',
  demandaOriginal: 'Demanda Original',
  destinatario: 'Destinatário',
  mensagemEnviada: 'Mensagem Encaminhada',

  //Dados do Fornecedor
  fornecedorId: 'ID do Fornecedor',
  cnpj: 'CNPJ',
  razaoSocial: 'Razão Social',
};

export const fieldObjectFornecedor = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'cnpjCnae.codigo',
  'naturezaJuridica.naturezaJuridica',
  'naturezaJuridica.codigo',
  'municipioIbge.ufSigla',
  'municipioIbge.municipio',
];

export const fieldObjectRepresentantesOuComunicacoes = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];

export const headersFornecedores = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: '' },
  { text: 'CNPJ', width: 15, key: '' },
  { text: 'Hierarquia', width: 10, key: '' },
  { text: 'Porte', width: 10, key: '' },
  // { text: 'Direito', width: 15, key: '' },
  { text: 'UF', width: 2, key: '' },
  { text: 'Fornecedor', width: 50, key: '' },
];

export const headersRepresentantes = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: '' },
  { text: 'Nome Completo', width: 30, key: '' },
  { text: 'Cargo', width: 27, key: '' },
  { text: 'Celular', width: 15, key: '' },
  { text: 'Email', width: 25, key: '' },
];

export const headersComunicacoes = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: '' },
  { text: 'Unidade DAF', width: 10, key: '' },
  { text: 'Tipo', width: 10, key: '' },
  { text: 'Tópico', width: 17, key: '' },
  { text: 'Assunto', width: 30, key: '' },
  { text: 'Status', width: 15, key: '' },
  { text: 'Data do envio', width: 15, key: '' },
];

export const headersUsuariosVinculados = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: '' },
  { text: 'Nome Completo', width: 25, key: '' },
  { text: 'CPF', width: 15, key: '' },
  { text: 'Celular', width: 15, key: '' },
  { text: 'Email', width: 25, key: '' },
  { text: 'Dt. Vinc.', width: 15, key: '' },
  { text: 'Resp. Vinc.', width: 25, key: '' },
  { text: 'Perfil', width: 10, key: '' },
  { text: 'Status', width: 10, key: '' },
];

export const valoresExibidosUsuariosVinculados = {
  id: 'ID',
  dataVinculacao: 'Data de Vinculação',
  observacao: 'Observação',

  nome: 'Nome Completo',
  cpf: 'CPF',
  email: 'Email',
  celular: 'Celular',

  statusInterface: 'Status Interface',
  statusRegistroAtivo: 'Status Registro',
};

export const headersHistoricoRT = [
  { text: 'ID', width: 5, key: 'id' },
  { text: 'Usuário', width: 20, key: 'usuario' },
  { text: 'CPF', width: 15, key: 'cpf' },
  { text: 'Telefone', width: 15, key: 'telefone' },
  { text: 'E-mail', width: 15, key: 'email' },
  { text: 'Resp. Vinc.', width: 25, key: '' },
  { text: 'Data Vinculação', width: 15, key: 'dataVinculacao' },
  { text: 'Data Desvinculação', width: 15, key: 'dataDesvinculacao' },
  { text: 'Vinculo', width: 10, key: 'vinculo' },
  { text: 'Status', width: 10, key: 'status' },
];

export const valoresExibidosHistoricoRT = {
  id: 'ID',
  nuInterfaceSisaf: 'Interface SISAF',
  usuario: 'Usuário Vinculado',
  cpf: 'CPF Usuário',
  dataVinculacao: 'Data Vinculação',
  dataDesvinculacao: 'Data Desvinculação',
  observacao: 'Observação',
  statusRegistroAtivo: 'Status',
};

export const fieldObjectHistoricoRT = {
  id: 'number',
  nuInterfaceSisaf: 'number',
  usuario: 'string',
  cpf: 'string',
  dataVinculacao: 'date',
  dataDesvinculacao: 'date',
  observacao: 'string',
  statusRegistroAtivo: 'string',
};
